


























































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { caijiMixin } from "./take-photos-video/caijiMixin";
import { getOptions } from "../common";
import SubTitle from "./title-sub.vue";
import Title from "./title.vue";
@Component({
  components: {
    Title,
    SubTitle,
  },
})
export default class Name extends mixins(caijiMixin) {
  @Prop()
  private content: any; // 整个content数据
  @Watch("content", { immediate: true })
  private contentChange() {
    if (this.content) {
      this.cContent = JSON.parse(JSON.stringify(this.content));
      // if (!this.cContent.report["舌象信息"]) {
      //   this.cContent.report["舌象信息"] = {
      //     舌神: ["", ""],
      //     舌色: ["", ""],
      //     舌形: ["", ""],
      //     舌态: ["", ""],
      //     苔质: ["", ""],
      //     苔色: ["", ""],
      //   };
      // }
    }
  }
  @Prop()
  private index: any; // 当前题目的索引
  @Prop()
  private data: any; // 题目的数据
  @Watch("data", { immediate: true })
  private dataChange() {
    if (this.data) {
      this.c = JSON.parse(JSON.stringify(this.data));
    }
  }
  @Prop()
  private source: any; //dialog,审核修改弹框;renkouxue,人口学和受试者信息;
  getOption(key: any) {
    return getOptions(key);
  }
  // 舌色和苔色改变,因为有联动，所以需要特殊处理下
  private changeSheTai(e: any, type: any) {
    if (type == "舌色") {
      this.cContent.report["舌色参数"][3][0] = e;
      this.$forceUpdate();
    } else if (type == "苔色") {
      this.cContent.report["苔色参数"][3][0] = e;
      this.$forceUpdate();
    }
    this.$emit("updateContent", this.cContent);
  }
}
